import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'EcommStoreProductPage',
})(({ breakpoints, typography }) => ({
  buyNowButton: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: typography.pxToRem(250),
    },
  },
}));

export default useStyles;
